import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

const resources = {
  ko: {
    translation: {
      menu: {
        company: '회사',
        product: '제품',
        case: '사례',
        contact: '문의'
      }
    }
  },
  en: {
    translation: {
      menu: {
        company: 'Company',
        product: 'Product',
        case: 'Case',
        contact: 'Contact'
      }
    }
  }
};

i18n
  .use(initReactI18next)
  .init({
    resources,
    lng: 'ko',
    fallbackLng: 'ko',
    interpolation: {
      escapeValue: false
    }
  });

export default i18n;